// CardNet Purchase Service
// Uses centralized callable so the correct Cloud Run URL is resolved (Functions v2).

import { processPayment } from './firebase/functions';

export class CardNetPurchaseService {
  static async processPurchase(data: any): Promise<any> {
    const result = await processPayment(data);
    return result.data;
  }
}
